<template>
  <div id="pageRoot">

    <span class="normalTheme pageInstruction" style="left: 55px; top: 55px;">
      <p>Mira el dibujo y lee la palabra.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 55px; top: 95px;">
      <p>Marca cada sílaba con un golpe.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 55px; top: 135px;">
      <p>Pinta tantos círculos como sílabas<br>tiene la palabra.</p>
    </span>

    <div class="textBubble" style="width:380px; height: 200px; left: 620px; top: 20px; border-radius: 5px;background-color: #00A5A5">
      <div class="textContainer textBase center" style="width: 90%; height: 90%;">
          <p class="center" style="font-size: 30px">Luego, en cada cartel, escribe otra palabra que tenga la misma cantidad de sílabas.</p>
      </div>
      <img class="arrow" src="/pages/img/general/arrow2.svg" style="top: 130px; left:300px; transform: scaleX(1);"/>
    </div>

    <img
    style="width: 150px; top: 210px; left: 70px"
    class="pageElement basicItem01"
    src="/pages/img/sordovio/assets_p24/grillo.svg"
    />

    <p class="textBase" style="top: 380px; left: 95px; font-size:32px; position: absolute;">GRILLO</p>

    <label
      class="checkMarkContainer-a"
      style="left: 294px; top: 322px; position: absolute"
      >Una Sílaba
      <input type="checkbox"
      checked="true" 
      disabled 
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 357px; top: 322px; position: absolute"
      >Dos Sílabas
      <input type="checkbox"
      checked="true" 
      disabled 
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 421px; top: 322px; position: absolute"
      >Tres Sílabas
      <input type="checkbox"
      disabled 
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 483px; top: 322px; position: absolute"
      >Cuatro Sílabas
      <input type="checkbox"
      disabled 
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 546px; top: 322px; position: absolute"
      >Cinco Sílabas
      <input type="checkbox"
      disabled 
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 610px; top: 322px; position: absolute"
      >Seis Sílabas
      <input type="checkbox"
      disabled 
        />
      <span class="checkmark-a"></span>
    </label>

    <div style="width: 230px; height: 200px; top: 280px; left: 730px; position: absolute;">
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="0"
      id="inputField01"
      class="centerH"
      defaultText="PATO"
      disabled
      style="position: absolute;
      width: 160px;
      height: 50px;
      top: 50px;
      z-index: 2"
    />
    <img
    style="width: 100%; z-index: -1"
    class="pageElement"
    src="/pages/img/general/pinnedTag.svg"
    />
    </div>

    <img
    style="width: 90%; top: 450px; left: 40px"
    class="pageElement"
    src="/pages/img/general/lineDivider.svg"
    />

    <img
    style="width: 200px; top: 520px; left: 60px"
    class="pageElement basicItem01"
    src="/pages/img/sordovio/assets_p24/chicharra.svg"
    />

    <p class="textBase" style="top: 660px; left: 65px; font-size:32px; position: absolute;">CHICHARRA</p>

    <label
      class="checkMarkContainer-a"
      style="left: 294px; top: 573px; position: absolute"
      >Una Sílaba
      <input type="checkbox"
        ref="b1" 
        v-on:change="saveOption('radios', 'b1')" 
        :onload="loadOption('radios', 'b1')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 357px; top: 573px; position: absolute"
      >Dos Sílabas
      <input type="checkbox"
        ref="b2" 
        v-on:change="saveOption('radios', 'b2')" 
        :onload="loadOption('radios', 'b2')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 421px; top: 573px; position: absolute"
      >Tres Sílabas
      <input type="checkbox"
        ref="b3" 
        v-on:change="saveOption('radios', 'b3')" 
        :onload="loadOption('radios', 'b3')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 483px; top: 573px; position: absolute"
      >Cuatro Sílabas
      <input type="checkbox"
        ref="b4" 
        v-on:change="saveOption('radios', 'b4')" 
        :onload="loadOption('radios', 'b4')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 546px; top: 573px; position: absolute"
      >Cinco Sílabas
      <input type="checkbox"
        ref="b5" 
        v-on:change="saveOption('radios', 'b5')" 
        :onload="loadOption('radios', 'b5')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 610px; top: 573px; position: absolute"
      >Seis Sílabas
      <input type="checkbox"
        ref="b6" 
        v-on:change="saveOption('radios', 'b6')" 
        :onload="loadOption('radios', 'b6')"
        />
      <span class="checkmark-a"></span>
    </label>

  <div style="width: 230px; height: 200px; top: 530px; left: 730px; position: absolute;">
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="centerH"
      style="position: absolute;
      width: 160px;
      height: 50px;
      top: 50px;
      z-index: 2"
    />
    <img
    style="width: 100%; z-index: -1"
    class="pageElement"
    src="/pages/img/general/pinnedTag.svg"
    />
  </div>
    
  </div>
</template>
<script>
  export default {
    methods:{
      dbId(name, option){
        return `${this.$parent.pageID()}-${name}-${option}`
      },
      async loadOption(name, option) {
        var id = this.dbId(name, option);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[option].checked=value.option;

        console.log("option loaded: " + id + ", " + value.option);
      },
      saveOption(name, option) {
        var id = this.dbId(name, option);
        var value = this.$refs[option].checked;

        this.$db.options.put({
              id: id,
              option: value
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + value);
      }
    },
    mounted(){

    }
  }
</script>